import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { LoaderCircle } from 'lucide-react';
import { Icon } from '@testbusters/icon';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      position="top-right"
      duration={5000}
      icons={{
        success: (
          <Icon
            name="circle-success-filled"
            className="text-xl mr-2"
          />
        ),
        info: (
          <Icon
            name="circle-info"
            className="text-2xl mr-2"
          />
        ),
        warning: (
          <Icon
            name="circle-warning"
            className="text-2xl mr-2"
          />
        ),
        error: (
          <Icon
            name="circle-error"
            className="text-2xl mr-2"
          />
        ),
        loading: <LoaderCircle className="size-6 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:shadow-lg group-[.toaster]:!text-button-primary-primary-default group-[.toaster]:!rounded-md group-[.toaster]:!p-6 group-[.toaster]:lg:!w-[400px]',
          description:
            'group-[.toast]:!text-button-primary-primary-default group-[.toast]:!text-xs',
          actionButton:
            'group-[.toast]:!bg-transparent group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:!bg-red-500 group-[.toast]:text-muted-foreground',
          success:
            '!bg-chips-semantic-success-light group-[.toaster]:!border-border-alert-success',
          error:
            '!bg-icon-alert-error/20 group-[.toaster]:!text-icon-alert-error !border-icon-alert-error',
          warning:
            '!bg-icon-alert-warning/20 group-[.toaster]:!text-icon-alert-warning !border-icon-alert-warning',
          info: '!bg-blue-50 !text-blue-900 !border-blue-200',
          title: 'group-[.toast]:!text-base',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
